//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

export const INSTAGRAM_DASHBOARD_HASHTAG_PAGE_LINK = (hashtag: string) =>
  `/instagram/hashtags/${hashtag}`;
export const LIBRARY_HASHTAG_PAGE_LINK = (hashtag: string) =>
  `/library/detail/instagram/hashtag/${hashtag}`;

angular.module('curalate').constant('ContentDetailPageLinks', {
  getInstagramDashboardHashtagLink: INSTAGRAM_DASHBOARD_HASHTAG_PAGE_LINK,
  getLibraryHashtagLink: LIBRARY_HASHTAG_PAGE_LINK,
});
